var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeparator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 19,
    viewBox: "0 0 6 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.64773 18.25C1.95833 18.25 1.36742 18.0076 0.875 17.5227C0.382576 17.0379 0.140152 16.447 0.147727 15.75C0.140152 15.0682 0.382576 14.4848 0.875 14C1.36742 13.5152 1.95833 13.2727 2.64773 13.2727C3.31439 13.2727 3.89394 13.5152 4.38636 14C4.88636 14.4848 5.14015 15.0682 5.14773 15.75C5.14015 16.2121 5.01894 16.6326 4.78409 17.0114C4.55682 17.3902 4.25379 17.6932 3.875 17.9205C3.50379 18.1402 3.0947 18.25 2.64773 18.25ZM2.64773 5.79545C1.95833 5.79545 1.36742 5.55303 0.875 5.06818C0.382576 4.57576 0.140152 3.98485 0.147727 3.29545C0.140152 2.61364 0.382576 2.0303 0.875 1.54545C1.36742 1.05303 1.95833 0.806818 2.64773 0.806818C3.31439 0.806818 3.89394 1.05303 4.38636 1.54545C4.88636 2.0303 5.14015 2.61364 5.14773 3.29545C5.14015 3.75 5.01894 4.16667 4.78409 4.54545C4.55682 4.92424 4.25379 5.22727 3.875 5.45455C3.50379 5.68182 3.0947 5.79545 2.64773 5.79545Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeparator);
export default __webpack_public_path__ + "static/media/Separator.ba100f856ebc7467993aa751f2530f38.svg";
export { ForwardRef as ReactComponent };